
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.horizontal-scroll {

    display: flex;

    justify-content: center
}

.horizontal-scroll__container {

    display: flex;

    overflow-x: scroll;

    padding-bottom: 1.25rem
}

.arrow-left, .arrow-right {

    position: relative;

    top: 2rem;

    height: 2.25rem;

    width: 2.25rem;

    border-width: 0px;

    display: flex;

    align-items: center;

    justify-content: center;

    border-radius: 0.25rem;

    background-color: var(--blue-responsible-main);

    color: var(--neutral-white);

    cursor: pointer
}

button[disabled] {

    cursor: default;

    background-color: var(--gray-professional-lighten-3)
}

.arrow-left {

    margin-right: 0.5rem
}

.arrow-right {

    margin-left: 0.5rem
}

.extra-space {

    margin-left: 0.5rem;

    margin-right: 0.5rem;

    display: block
}
`;